module.exports = __webpack_public_path__ + "static/media/jasperactive-logo-red.cb950877.svg";